import React from 'react'
import DiveClubDetails from '../../../Components/Organisms/DiveClubs/DiveClubDetails.jsx'

function DiveClubDetailsTemplate({diveClubData, roles}) {
  return (
    <DiveClubDetails diveClubData={diveClubData} roles={roles} />
  )
}

export default DiveClubDetailsTemplate